module.exports = __webpack_public_path__ + "static/synesthesia-demo-87493dc93a1930c4346d3c8af46b1807.webm";